"use strict";
import e from "./index.es99.js";
import f from "./index.es110.js";
import l from "./index.es143.js";
import c from "./index.es109.js";
import u from "./index.es144.js";
import m from "./index.es145.js";
import h from "./index.es104.js";
function S(t, i, r) {
  if (e.isString(t))
    try {
      return (i || JSON.parse)(t), e.trim(t);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(t);
}
const p = {
  transitional: l,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, i) {
    const r = i.getContentType() || "", n = r.indexOf("application/json") > -1, s = e.isObject(t);
    if (s && e.isHTMLForm(t) && (t = new FormData(t)), e.isFormData(t))
      return n ? JSON.stringify(h(t)) : t;
    if (e.isArrayBuffer(t) || e.isBuffer(t) || e.isStream(t) || e.isFile(t) || e.isBlob(t) || e.isReadableStream(t))
      return t;
    if (e.isArrayBufferView(t))
      return t.buffer;
    if (e.isURLSearchParams(t))
      return i.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let o;
    if (s) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return u(t, this.formSerializer).toString();
      if ((o = e.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const a = this.env && this.env.FormData;
        return c(
          o ? { "files[]": t } : t,
          a && new a(),
          this.formSerializer
        );
      }
    }
    return s || n ? (i.setContentType("application/json", !1), S(t)) : t;
  }],
  transformResponse: [function(t) {
    const i = this.transitional || p.transitional, r = i && i.forcedJSONParsing, n = this.responseType === "json";
    if (e.isResponse(t) || e.isReadableStream(t))
      return t;
    if (t && e.isString(t) && (r && !this.responseType || n)) {
      const s = !(i && i.silentJSONParsing) && n;
      try {
        return JSON.parse(t, this.parseReviver);
      } catch (o) {
        if (s)
          throw o.name === "SyntaxError" ? f.from(o, f.ERR_BAD_RESPONSE, this, null, this.response) : o;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: m.classes.FormData,
    Blob: m.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
e.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  p.headers[t] = {};
});
export {
  p as default
};
//# sourceMappingURL=index.es103.js.map
